import {
  Button,
  If,
  Otp,
  useHasRequiredFormError,
  useI18n,
  widgets,
} from '@nosinovacao/nosid-mfe-common';
import { type UpdatePinProps } from '../-model/props';
import { SkeletonLight } from '@/components/skeleton/skeleton.light';
import { Loader } from '@nosinovacao/fe-icons';

export function UpdatePinLight({ form, isLoading, submit }: Readonly<UpdatePinProps>) {
  const { t } = useI18n();
  const hasRequiredError = useHasRequiredFormError(form);
  return (
    <form
      data-tid="form-update-pin"
      className="flex size-full flex-col items-center"
      onSubmit={form.handleSubmit(submit)}
    >
      <SkeletonLight loading={isLoading} className="h-12 w-52">
        <Otp
          data-tid="otp-pin"
          id="pin"
          skin="light"
          length={widgets.PinCodeLength}
          value={form.value.pin}
          onChange={(v) => {
            form.setValue('pin', v);
          }}
        />
      </SkeletonLight>
      <div className="mt-auto grid w-full max-tablet:pb-8">
        <Button
          data-tid="button-submit-pin"
          skin="light"
          disabled={isLoading || form.pristine || hasRequiredError}
          className="w-full tablet:w-fit"
        >
          <If condition={isLoading} otherwise={t('Pins.ChangePin.Submit')}>
            <Loader width={24} height={24} />
          </If>
        </Button>
      </div>
    </form>
  );
}
